import React from 'react';

const EligibilityVerification: React.FC = () => {
  return null;
};

export default EligibilityVerification;
